import Grid from "@material-ui/core/Grid";
import React from "react";
import "../../Assets/SCSS/components/Pageheader.scss";

const PageHeader = (props) => (
  <Grid item xs={12} md={12} sm={12}>
    <div className={`${props.className ? props.className : ""}`}>
      <span className="page-header-name">{props.header}</span>
      {props.subheader && <span className="page-subheader-name">{props.subheader}</span>}
    </div>
  </Grid>
);

export default PageHeader;
